// import package
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Button, Select, MenuItem } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

// import component
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// import action
import { withdrawRequestFiat, payatMeWithdrawReq } from '../../actions/walletAction';

// import lib
import isEmpty from '../../lib/isEmpty';
import { fiatValidation } from './validation'
import { toastAlert } from "../../lib/toastAlert";
import { precentConvetPrice } from '../../lib/calculation';
import { encryptObject } from '../../lib/cryptoJS'

const initialFormValue = {
    'currencyId': '',
    'amount': '',
    'twoFACode': '',
    'bankId': '',
    'finalAmount': '',
    'otpTextBox': false,
    'otp': '',
}

const PayatMeWithdraw = (props) => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    // props
    const { show, assetData, currency, onHide } = props;

    // state
    const [formValue, setFormValue] = useState(initialFormValue);
    const [bankOption, setBankOption] = useState([])
    const [validateError, setValidateError] = useState({});
    const [loader, setLoader] = useState(false)

    const {
        amount,
        twoFACode,
        bankId,
        finalAmount,
        otpTextBox,
        otp
    } = formValue;

    // redux-state
    const bankDetail = useSelector(state => state.bankDetail);

    // function
    const handleClose = () => {
        setFormValue(initialFormValue)
        setValidateError({})
        onHide()
    }

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        if (!isEmpty(validateError)) {
            setValidateError({})
        }

        if (name == 'amount') {
            // let finalAmountBal = parseFloat(value) + precentConvetPrice(value, currency.withdrawFee); // percentage withdraw
            let finalAmountBal = parseFloat(value) + parseFloat(currency.withdrawFee); // amount withdraw
            let formData = { ...formValue, ...{ [name]: value, 'finalAmount': finalAmountBal } }
            setFormValue(formData)
            return
        }

        if (name == 'otp') {
            if (!(value == '' || (/^[0-9\b]+$/.test(value) && value.length <= 6))) {
                return
            }
        }
        let formData = { ...formValue, ...{ [name]: value } }
        setFormValue(formData)
    }

    const handleSubmit = async () => {
        setLoader(true)
        let reqData = {
            currencyId: assetData._id,
            minimumWithdraw: currency.minimumWithdraw,
            coin: currency.coin,
            amount,
            bankId,
            twoFACode,
            finalAmount,
            spotBal: assetData.spotBal,
            timeStamp: new Date().getTime(),
            otpTextBox,
            otp
        }

        let validationError = fiatValidation(reqData, t)
        if (!isEmpty(validationError)) {
            setValidateError(validationError)
            setLoader(false)
            return
        }

        let encryptToken = {
            token: encryptObject(reqData)
        }

        try {
            const { status, loading, error, message } = await payatMeWithdrawReq(encryptToken, dispatch)
            setLoader(loading)
            if (status == 'success') {
                setFormValue(initialFormValue)
                toastAlert('success', t(message), 'withdraw');
                handleClose()
            } else if(status == 'OTP'){
                setFormValue({...formValue,...{'otpTextBox' : true } })
                toastAlert('success', t(message), 'withdraw');
                return
            } else {
                if (error) {
                    setValidateError(error)
                    return
                }
                toastAlert('error', t(message), 'withdraw');
            }
        }
        catch (err) { }
    }

    useEffect(() => {
        if (bankDetail && bankDetail.result && bankDetail.result.length > 0) {
            setBankOption(bankDetail.result)
            let defaultBank = bankDetail.result.find(el => el.isPrimary == true);
            if (defaultBank) {
                setFormValue((el) => {
                    return { ...el, 'bankId': defaultBank._id }
                })
            }
        }
    }, [bankDetail])

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('WITHDRAW_FIAT')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={6} lg={6}>
                        <div class="form-group select_lable_">
                            <label>
                            {t("WITHDRAW_ACCOUNT")}
                                {/* <Link to={'/profile'}>+ {t("ADD_BANK")}</Link> */}
                            </label>
                            <Select
                                name={"bankId"}
                                value={bankId}
                                onChange={handleChange}
                                disabled={otpTextBox}
                            >
                                {
                                    bankOption && bankOption.length > 0 && bankOption.map((el, index) => {
                                        return (
                                            <MenuItem key={index} value={el._id}>
                                                {el.bankName}{' '}{el.accountNo}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            {validateError.bankId && <p className="error-message">{t(validateError.bankId)}</p>}
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={6}>
                        <label>{t('AMOUNT')}</label>
                        <div className="form-group  ">
                            <div class="seacr_box_s">
                                <input type="text" placeholder=""
                                    name='amount'
                                    value={amount}
                                    onChange={handleChange}
                                    disabled={otpTextBox}
                                />
                                <i class="">{assetData && assetData.coin}</i>
                            </div>
                        </div>
                        {validateError.amount && <p className="error-message">{t(validateError.amount).replace('##MINIMUM_WITHDRAW##',currency.minimumWithdraw)}</p>}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                        <div className="wallwt_balance">
                            <p>{t('WALLET_BALANCE')} <span>{assetData && assetData.spotBal} {assetData && assetData.coin}</span></p>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={6}>
                        <label>{t('FINAL_WITHDRAW_AMOUNT')}</label>
                        <div className="form-group  ">
                            <div class="seacr_box_s">
                                <input type="text" placeholder=""
                                    value={finalAmount}
                                    disabled
                                />
                                <i class="">{assetData && assetData.coin}</i>
                            </div>
                        </div>
                        {validateError.finalAmount && <p className="error-message">{t(validateError.finalAmount)}</p>}
                    </GridItem>
                { otpTextBox &&    
                    <GridItem xs={12} sm={12} md={12} lg={6}>
                        <label>{t('ENTER_OTP_CODE')}</label>
                        <div className="form-group  ">
                            <div class="seacr_box_s">
                                <input type="text"
                                    placeholder=""
                                    name='otp'
                                    value={otp}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        {validateError.otp && <p className="error-message">{t(validateError.otp)}</p>}
                    </GridItem>
                }    
                    <div className="submit_btn w-100">
                        <Button className="w-100"
                            onClick={handleSubmit}
                            disabled={loader}
                        >
                            {loader && <i className="fas fa-spinner fa-spin"></i>}
                            {t("WITHDRAW")}
                        </Button>
                    </div>

                    <div className="notes_section">
                        <p>{t('NOTES')}</p>
                        <ul>
                            <li>1. {t('MIN_WITHDRAW_LIMIT').replace('##CURRENCY##',currency.coin).replace('##MIN_WITHDRAW##',currency.minimumWithdraw)}</li>
                            <li>2. {t('WITHDRAW_FEE').replace('##WITHDRAW_FEE##',currency.withdrawFee).replace('##CURRENCY##',currency.coin)}</li>
                            <li>3. {t('WITHDRAW_FIAT_TIME_TAKE')}</li>
                        </ul>
                    </div>
                </GridContainer>
            </Modal.Body >
        </Modal >
    )
}

export default PayatMeWithdraw;